<template>
  <div class="container d-flex justify-content-center align-items-center formulario" style="margin-top: 10px;">
    <div class="text-center col-12 col-md-12">
      <div class="mb-4" @click="goBack" style="color: #136A9F; font-weight: bolder;">
        <span class='d-flex align-items-center back_button' @click="voltarParaLista">
          <el-icon color="#136A9F" style="font-size: 27px;"><Back /></el-icon>
          Voltar
        </span>
      </div>

      <img src="/banner.png" alt="Logo" class="img-fluid mb-4" style="width: 128px; margin-top: 10px;">

      <h1 class="losta_masca">Ficha de Decisão Individual</h1>

      <div style="text-align: right;">

          <div>
              <button v-if="!isEdicao" class="btn btn-link text-decoration-underline" @click="showModal = true">Limpar dados</button>
              <button class="btn btn-primary mb-3 botao_padrao btn-registrar-ocorrencia" style="margin-right: 10px; " @click="toggleModalOcorrencia" v-if="user.showMapeamento && isEdicao">Registrar Ocorrência</button>
              <button class="btn btn-primary mb-3 btn_editar botao_padrao" v-if="isEdicao && user.showhistoricoCongregado" @click="goToHistorico">Histórico</button>
              <button v-if="isEdicao && !isEditable" class="btn btn-primary mb-3 btn_editar botao_padrao" @click="toggleEdit" style="margin-left: 10px;">Editar</button>
          </div>
      </div>

      <div style="display: flex; justify-content: space-between; align-items: center;">
        <h2 class="text-start my-title" style="font-size: 1.5rem;">Congregacional</h2>
      </div>
      
      <!-- Campo Eclesiástico -->
      <SelectWithIcon
        v-model:selectedValue="campoSelected"
        :options="campos"
        :visible="user.showCampoInput"
        label="Campo Eclesiástico"
        placeholder="Campo Eclesiástico"
        iconSrc="https://img.icons8.com/?size=100&id=7880&format=png&color=B0B2B3"
        :is-editable="isEditable"
      />

      <!-- Filial -->
      <SelectWithIcon
        v-model:selectedValue="igrejaSelected"
        :options="igrejas"
        :visible="user.showFilialInput && (igrejas?.length > 1)"
        label="Filial"
        placeholder="Filial"
        iconSrc="https://img.icons8.com/?size=100&id=7880&format=png&color=B0B2B3"
        :is-editable="isEditable"
      />

      <!-- Setor -->
      <SelectWithIcon
        v-model:selectedValue="setorSelected"
        :options="setores"
        :visible="user.showSetorInput && (setores?.length > 1)"
        label="Setor"
        placeholder="Setor"
        iconSrc="https://img.icons8.com/?size=100&id=7880&format=png&color=B0B2B3"
        :is-editable="isEditable"
      />

      <!-- Congregação -->
      <SelectWithIcon
        v-model:selectedValue="congregacaoSelected"
        :options="congregacoes"
        label="Congregação"
        placeholder="Congregação"
        :visible="true"
        iconSrc="https://img.icons8.com/?size=100&id=7880&format=png&color=B0B2B3"
        :errors="errors?.congregacao_id"
        :is-editable="isEditable"
      />

      
      <h2 class="text-start my-title" style="font-size: 1.5rem;">Pessoal</h2>
      <!-- Nome completo -->
      <div class="form-floating mb-3 position-relative">
        <img 
          class="position-absolute top-50 start-0 translate-middle-y ps-3" 
          src="https://img.icons8.com/?size=100&id=83151&format=png&color=B0B2B3" 
          alt="" width="40px" style="z-index: 9;"
        >
            
        <input 
          :disabled="!isEditable"
          v-model="nome" 
          type="text" 
          :class="['form-control ps-5', { 'error-border': errors && Object.keys(errors).length && errors.nome }]"
          id="nome" 
          placeholder="Nome completo" 
          required
        >
              
        <label for="nome" class="ps-5">Nome completo<span class="text-danger">*</span></label>
      </div>
      <p v-if="errors && Object.keys(errors).length && errors.nome" class="text-danger error">{{ errors.nome[0] }}</p>

      <DateInputWithIcon
        v-model="data_nascimento"
        :errors="errors?.data_nascimento || []"
        :is-editable="isEditable"
        label="Data de Nascimento"
        placeholder="Data de Nascimento"
        input-id="data_nascimento"
        :required="congregacaoSelected !== 101426"
      />

      <!-- Whatsapp -->
      <PhoneInputWithIcon
        v-model="telefone_celular"
        :errors="errors?.telefone_celular"
        :is-editable="isEditable"
        :required="congregacaoSelected === 101426"
      />

      
      <h2 class="text-start my-title" style="font-size: 1.5rem;">Endereço</h2>

      <!-- CEP -->
      <CepInputWithIcon
        v-model="cep"
        :is-editable="isEditable"
        @change="buscarEndereco"
      />


      <!-- Rua -->
      <div class="form-floating mb-3 position-relative">
        <img class="position-absolute top-50 start-0 translate-middle-y ps-3" 
            src="https://img.icons8.com/?size=100&id=7880&format=png&color=B0B2B3" 
            alt="Ícone de endereço" width="40px" style="z-index: 9;">
            
        <input
            :disabled="!isEditable"
            v-model="endereco" 
            type="text" 
            :class="['form-control ps-5', { 'error-border': errors && Object.keys(errors).length && errors.endereco }]"
            id="endereco" 
            placeholder="Rua" 
            required
        >
              
        <label for="endereco" class="ps-5">Rua</label>
      </div>
      <p v-if="errors && Object.keys(errors).length && errors.endereco" class="text-danger error">{{ errors.endereco[0] }}</p>

      <!-- Numero -->
      <div class="form-floating mb-3 position-relative">
        <!-- Ícone dentro do campo -->
        <img class="position-absolute top-50 start-0 translate-middle-y ps-3" 
            src="https://img.icons8.com/?size=100&id=7880&format=png&color=B0B2B3" 
            alt="Ícone de número" width="40px" style="z-index: 9;">
            
        <!-- Input de texto com Floating Label para o número -->
        <input
          inputmode="numeric"
          v-model="numero" 
          :disabled="!isEditable"
          type="text" 
          :class="['form-control ps-5', { 'error-border': errors && Object.keys(errors).length && errors.numero }]"
          id="numero" 
          placeholder="Número" 
          @input="formatarNumero"
          required
          >
              
        <!-- Label flutuante -->
        <label for="numero" class="ps-5">Número</label>
      </div>
      <p v-if="errors && Object.keys(errors).length && errors.numero" class="text-danger error">{{ errors.numero[0] }}</p>

      <!-- Bairro -->
      <div class="form-floating mb-3 position-relative">
        <!-- Ícone dentro do campo -->
        <img class="position-absolute top-50 start-0 translate-middle-y ps-3" 
            src="https://img.icons8.com/?size=100&id=7880&format=png&color=B0B2B3" 
            alt="Ícone de bairro" width="40px" style="z-index: 9;">
            
        <!-- Input de texto com Floating Label para o bairro -->
        <input v-model="bairro"
          :disabled="!isEditable"
          type="text" 
          class="form-control ps-5" 
          id="bairro" 
          placeholder="Bairro" 
          :class="{ 'error-border': errors && Object.keys(errors).length && errors.bairro }"
          required
        >
              
        <!-- Label flutuante -->
        <label for="bairro" class="ps-5">Bairro</label>
      </div>
      <p v-if="errors && Object.keys(errors).length && errors.bairro" class="text-danger error">{{ errors.bairro[0] }}</p>

      <!-- Complemento -->
      <div class="form-floating mb-3 position-relative">
        <!-- Ícone dentro do campo -->
        <img class="position-absolute top-50 start-0 translate-middle-y ps-3" 
            src="https://img.icons8.com/?size=100&id=7880&format=png&color=B0B2B3" 
            alt="Ícone de complemento" width="40px" style="z-index: 9;">
            
        <!-- Input de texto com Floating Label para o complemento -->
        <input v-model="complemento" 
            :disabled="!isEditable"
            type="text" 
            :class="['form-control', { 'error-border': errors && Object.keys(errors).length && errors.complemento }]"
            id="complemento" 
            placeholder="Complemento" 
            required
        >

              
        <!-- Label flutuante -->
        <label for="complemento" class="ps-5">Complemento</label>
      </div>
      <p v-if="errors && Object.keys(errors).length && errors.complemento" class="text-danger error">{{ errors.complemento[0] }}</p>

      <!-- CIDADE -->
      <SelectWithIcon
        v-model:selectedValue="cidade"
        :options="cities"
        label="Cidade"
        placeholder="Cidade"
        iconSrc="https://img.icons8.com/?size=100&id=7880&format=png&color=B0B2B3"
        :isEditable="isEditable"
      />

      <!-- UF -->
      <SelectWithIcon
        v-model:selectedValue="uf"
        :options="ufs"
        label="Estado"
        placeholder="UF"
        iconSrc="https://img.icons8.com/?size=100&id=7880&format=png&color=B0B2B3"
        :isEditable="false"
      />


      <h2 class="text-start my-title" style="font-size: 1.5rem;">Decisão</h2>

      <!-- Faixa Etária -->
      <SelectWithIcon
        v-if="!data_nascimento"
        v-model:selectedValue="faixaEtaria"
        :options="[
          { label: 'Criança (até 11 anos e 11 meses)', value: 'crianca' },
          { label: 'Adolescente (12 anos aos 17 anos e 11 meses)', value: 'adolescente' },
          { label: 'Jovem/adulto (18 anos acima)', value: 'jovem_adulto' }
        ]"
        label="Faixa etária"
        placeholder="Selecione a faixa etária"
        iconSrc="https://img.icons8.com/?size=100&id=7885&format=png&color=B0B2B3"
        :errors="errors?.faixa_etaria"
        :isEditable="isEditable"
        :required="congregacaoSelected !== 101426"
      />

      <!-- Tipo de Decisão -->
      <SelectWithIcon
        v-model:selectedValue="tipoDeDecisao"
        :options="[
          { label: 'Conversão (Aceitou Jesus)', value: 'Conversão (Aceitou Jesus)' },
          { label: 'Reconciliação (Voltou para Jesus)', value: 'Reconciliação (Voltou para Jesus)' }
        ]"
        label="Tipo de Decisão"
        placeholder="Selecione o Tipo de Decisão"
        iconSrc="https://img.icons8.com/?size=100&id=36389&format=png&color=B0B2B3"
        :errors="errors?.tipo_decisao"
        :isEditable="isEditable"
        :required="congregacaoSelected !== 101426"
      />

      <!-- Local de Decisão -->
      <SelectWithIcon
        v-model:selectedValue="localDecisao"
        :options="[
          { label: 'Templo', value: 'Templo' },
          { label: 'Ar livre', value: 'Ar livre' },
          { label: 'Trabalho', value: 'Trabalho' },
          { label: 'Residência', value: 'Residência' },
          { label: 'Outro', value: 'Outro' }
        ]"
        label="Local de Decisão"
        placeholder="Selecione o local de decisão"
        iconSrc="https://img.icons8.com/?size=100&id=7885&format=png&color=B0B2B3"
        :errors="errors?.local_decisao"
        :isEditable="isEditable"
      />

      <!-- Pode ser visitado -->
      <SelectWithIcon
        v-model:selectedValue="podeSerVisitado"
        :options="[
          { label: 'Sim', value: 1 },
          { label: 'Não', value: 0 }
        ]"
        label="Pode ser visitado?"
        placeholder="Pode ser visitado?"
        iconSrc="https://img.icons8.com/?size=100&id=2797&format=png&color=B0B2B3"
        :errors="errors?.pode_visita"
        :isEditable="isEditable"
        :required="congregacaoSelected !== 101426"
      />

      <!-- Data de conversão -->
      <DateInputWithIcon
        v-model="dataConversao"
        :errors="errors?.data_conversao || []"
        :is-editable="isEditable"
        label="Data de Decisão"
        placeholder="Data de Decisão"
      />

      <!-- Informações Adicionais -->
      <TextareaWithIcon
        v-model="informacoesAdicionais"
        label="Informações Adicionais"
        placeholder="Informações Adicionais"
        :iconSrc="'https://img.icons8.com/?size=100&id=83151&format=png&color=B0B2B3'"
        :errors="errors?.informacoesAdicionais"
        :is-editable="isEditable"
      />

      <div v-if="user.showMapeamento">
        <h2 class="text-start my-title" style="font-size: 1.5rem;">Acompanhamento</h2>

        <SelectWithIcon
          v-model:selectedValue="origem"
          :options="[
            { label: 'Recebido', value: 'Recebido' },
            { label: 'Transferido', value: 'Transferido' },
            { label: 'Desistência', value: 'Desistência' }
          ]"
          label="Origem"
          placeholder="Origem"
          iconSrc="https://img.icons8.com/?size=100&id=59809&format=png&color=B0B2B3"
          :isEditable="isEditable"
        />


        <div class="row d-flex" style="margin-left: -12px; margin-right: -12px;">
          <el-switch
            :disabled="!isEditable"
            v-model="endereco_localizado"
            active-text="Endereço localizado"
          />
        </div>
        
        <div class="row d-flex" style="margin-left: -12px; margin-right: -12px;">
          <el-switch
            :disabled="!isEditable"
            v-model="participa_betel"
            active-text="Participa do conjunto Betel"
          />
        </div>

        <div class="row d-flex" style="margin-left: -12px; margin-right: -12px;">
          <el-switch
            :disabled="!isEditable"
            v-model="sendo_discipulado"
            active-text="Está Sendo Discipulado"
          />
        </div>

        <h3 class="text-start my-title">EBD</h3>
        <div class="row" style="margin-left: -12px; margin-right: -12px;">
          <!-- EBD -->
          <SwitchDateInput
            v-model:switchValue="ebd_inicio"
            v-model:dateValue="ebd_inicio_data"
            :errors="errors?.ebd_inicio_data || []"
            :is-editable="isEditable"
            label="Matrícula"
            placeholder="Data de Matrícula"
          />
          <SwitchDateInput
            v-model:switchValue="ebd_conclusao"
            v-model:dateValue="ebd_conclusao_data"
            :errors="errors?.ebd_conclusao_data || []"
            :is-editable="isEditable"
            label="Conclusão"
            placeholder="Data de Conclusão"
            activeText="Conclusão"
          />
        </div>

        <h3 class="text-start my-title">Curso Bíblico Individual</h3>
        <div class="row" style="margin-left: -12px; margin-right: -12px;">
          <SwitchDateInput
            v-model:switchValue="curso_biblico_individual_inicio"
            v-model:dateValue="curso_biblico_individual_inicio_data"
            :errors="errors?.curso_biblico_individual_inicio_data || []"
            :is-editable="isEditable"
            label="Matrícula"
            placeholder="Matrícula"
          />

          <SwitchDateInput
            v-model:switchValue="curso_biblico_individual_conclusao"
            v-model:dateValue="curso_biblico_individual_conclusao_data"
            :errors="errors?.curso_biblico_individual_conclusao_data || []"
            :is-editable="isEditable"
            label="Conclusão"
            placeholder="Data de Conclusão"
            activeText="Conclusão"

          />
        </div>

        <h3 class="text-start my-title">Curso Bíblico no Ar</h3>
        <div class="row" style="margin-left: -12px; margin-right: -12px;">
          <SwitchDateInput
            v-model:switchValue="curso_biblico_ar_inicio"
            v-model:dateValue="curso_biblico_ar_inicio_data"
            :errors="errors?.curso_biblico_ar_inicio_data || []"
            :is-editable="isEditable"
            label="Matrícula"
            placeholder="Matrícula"
          />

          <SwitchDateInput
            v-model:switchValue="curso_biblico_ar_conclusao"
            v-model:dateValue="curso_biblico_ar_conclusao_data"
            :errors="errors?.curso_biblico_ar_conclusao_data || []"
            :is-editable="isEditable"
            label="Conclusão"
            placeholder="Data de Conclusão"
            activeText="Conclusão"

          />
        </div>

        <h3 class="text-start my-title">Processo de Discipulado</h3>
        <div class="row mb-4" style="margin-left: -12px; margin-right: -12px;">
          <SwitchDateInput
            v-model:switchValue="discipulado_inicio"
            v-model:dateValue="discipulado_inicio_data"
            :errors="errors?.discipulado_inicio_data || []"
            :is-editable="isEditable"
            label="Matrícula"
            placeholder="Matrícula"
          />

          <SwitchDateInput
            v-model:switchValue="discipulado_conclusao"
            v-model:dateValue="discipulado_conclusao_data"
            :errors="errors?.discipulado_conclusao_data || []"
            :is-editable="isEditable"
            label="Conclusão"
            placeholder="Data de Conclusão"
            activeText="Conclusão"

          />
        </div>


      </div>

      <button v-if="!isEdicao" type="submit" class="btn btn-primary form-control submit_button" style="background: #136A9F !important;" @click="sendData">Enviar</button>
      <button v-if="isEdicao" type="submit" class="btn btn-primary form-control submit_button" style="background: #136A9F !important;" @click="updateData">Editar</button>

      <!-- Modal de Confirmação -->
      <div v-if="showModal" class="modal-overlay">
        <div class="modal" tabindex="-1" role="dialog" style="display: block;">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Confirmação</h5>
              </div>
              <div class="modal-body">
                <p>Tem certeza que deseja limpar todos os dados do presente formulário?</p>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" @click="showModal = false">Cancelar</button>
                <button type="button" class="btn btn-primary" @click="limparDados">Confirmar</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ModalRegistroOcorrencia
        :show="showModalRegistro"
        :num_ficha="num_ficha"
        :model-value="registroOcorrenciaForm"
        @close="toggleModalOcorrencia"
        @submit="handleSubmitOcorrencia"
      />
    </div>
  </div>
</template>

<script>
import colheitaService from "@/services/colheitaService";
import environment from '@/config/environment';
import ModalRegistroOcorrencia from '@/components/ModalRegistroOcorrencia.vue'
import SwitchDateInput from '@/components/SwitchDateInput.vue'
import DateInputWithIcon from '@/components/DateInputWithIcon.vue'
import SelectWithIcon from '@/components/SelectWithIcon.vue'
import PhoneInputWithIcon from '@/components/PhoneInputWithIcon.vue'
import CepInputWithIcon from '@/components/CepInputWithIcon.vue'
import TextareaWithIcon from '@/components/TextareaWithIcon.vue'


export default {
  components: { 
    ModalRegistroOcorrencia, 
    SwitchDateInput,
    DateInputWithIcon,
    SelectWithIcon,
    PhoneInputWithIcon,
    CepInputWithIcon,
    TextareaWithIcon
  },

  name: 'MainApp',

  data() {
    return {
        user: this.$root.user || {},
        token: this.$root.token || {},

        num_ficha: this.$route.params.num_ficha ?? null,

        faixaEtaria: '',

        // informações dos selects
        campos: [],
        igrejas: [],
        setores: [],
        congregacoes: [],
        ufs: [],
        cities: [],

        // informacoes a serem submetidas
        campoSelected: '',
        igrejaSelected: '',
        setorSelected: '',
        congregacaoSelected: '',
        nome: '',
        data_nascimento: '',
        telefone_celular: '',
        dataConversao: '',
        cep: '',
        uf: 'RN',
        cidade: '',
        endereco: '',
        numero: '',
        bairro: '',
        complemento: '',
        tipoDeDecisao: '',
        localDecisao: '',
        podeSerVisitado: "",
        informacoesAdicionais: "",

        origem: "",
        endereco_localizado: false,
        participa_betel: false,
        sendo_discipulado: false,

        ebd_inicio: false,
        ebd_inicio_data: null,
        ebd_conclusao: false,
        ebd_conclusao_data: null,

        curso_biblico_individual_inicio: false,
        curso_biblico_individual_inicio_data: null,
        curso_biblico_individual_conclusao: false,
        curso_biblico_individual_conclusao_data: null,

        curso_biblico_ar_inicio: false,
        curso_biblico_ar_inicio_data: null,
        curso_biblico_ar_conclusao: false,
        curso_biblico_ar_conclusao_data: null,

        discipulado_inicio: false,
        discipulado_inicio_data: null,
        discipulado_conclusao: false,
        discipulado_conclusao_data: null,

        isEditable: true,
        isEdicao: false,
        isMounted: false,

        // Mensagem de campos obrigatorios
        errors: {},
        isSubmitting: false,
        showModal: false,
        showModalRegistro: false,

        registroOcorrenciaForm: {
          num_ficha_colheita: this.num_ficha,
          cpf_rol: '',
          nome: '',
          tipo: '',
          data: '',
          observacoes: ''
        }

    };
  },
  beforeMount() {


    if(this.num_ficha)
    {
      this.isEdicao = true;
      this.isEditable = false;
    } else {
        this.isEditable = true;
        this.loadFromLocalStorage();
    }
  },

  mounted() {
    if(this.isEdicao)
      this.getFicha();

    this.fechUserInfos();

    // Sempre preenche data de decisão com hoje, exceto em modo edição
    if(!this.isEdicao) {
      this.formatarDataAtual();
    }

    this.fetchCityByUf();
    this.changeSelects();

    this.isMounted = true;


  },
  watch: {
    campoSelected(value) {
      if (this.isMounted) {
        if(this.isEditable && this.user.showIgrejaInput)
          this.igrejaSelected = '';

        this.changeSelects();
        this.saveToLocalStorage('campoSelected', value);
      }
    },
    igrejaSelected(value) {
      if (this.isMounted) {
        // if(this.isEditable && this.user.showSetorInput)
        //   this.setorSelected = '';

        this.changeSelects();
        this.saveToLocalStorage('igrejaSelected', value);
      }
    },
    setorSelected(value) {
      if (this.isMounted) {
        if(this.isEditable && this.user.showCongregacaoInput)
          this.congregacaoSelected = '';

        this.changeSelects();
        this.saveToLocalStorage('setorSelected', value);
      }
    },
    congregacaoSelected(value) {
      if (this.isMounted) {
        this.saveToLocalStorage('congregacaoSelected', value);

        // Se for congregação 101426, preencher Local de Decisão como "Outro"
        if (value === 101426) {
          this.localDecisao = 'Outro';
        }
      }
    },
    nome(value) {
      if (this.isMounted) {
        this.saveToLocalStorage('nome', value);
      }
    },
    data_nascimento(value) {
      if (this.isMounted) {
        this.saveToLocalStorage('data_nascimento', value);

        let dataNascimento = value;

        const dataParts = dataNascimento.split('/');
        const dia = parseInt(dataParts[0], 10);
        const mes = parseInt(dataParts[1], 10) - 1; // Mês é 0-indexado
        const ano = parseInt(dataParts[2], 10);
        const dataNasc = new Date(ano, mes, dia);
        const hoje = new Date();

        // Calcula a idade
        let idade = hoje.getFullYear() - dataNasc.getFullYear();
        const mesAtual = hoje.getMonth();
        const diaAtual = hoje.getDate();

        if (mesAtual < mes || (mesAtual === mes && diaAtual < dia)) {
          idade--;
        }

        if (idade < 12) {
          this.faixaEtaria = 'crianca';
        } else if (idade >= 12 && idade < 18) {
          this.faixaEtaria = 'adolescente';
        } else {
          this.faixaEtaria = 'jovem_adulto';
        }
      }
    },
    telefone_celular(value) {
      if (this.isMounted) {
        this.saveToLocalStorage('telefone_celular', value);
      }
    },
    endereco(value) {
      if (this.isMounted) {
        this.saveToLocalStorage('endereco', value);
      }
    },
    localDecisao(value) {
      if (this.isMounted) {
        this.saveToLocalStorage('localDecisao', value);
      }
    },
    podeSerVisitado(value) {
      if (this.isMounted) {
        this.saveToLocalStorage('podeSerVisitado', value);
      }
    },
    cep(value) {
      if (this.isMounted) {
        this.saveToLocalStorage('cep', value);
      }
    },
    bairro(value) {
      if (this.isMounted) {
        this.saveToLocalStorage('bairro', value);
      }
    },
    cidade(value) {
      if (this.isMounted) {
        this.saveToLocalStorage('cidade', value);
      }
    },
    uf(value) {
      if (this.isMounted) {
        this.saveToLocalStorage('uf', value);
      }
    },
    tipoDeDecisao(value) {
      if (this.isMounted) {
        this.saveToLocalStorage('tipoDeDecisao', value);
      }
    },
    numero(value) {
      if (this.isMounted) {
        this.saveToLocalStorage('numero', value);
      }
    },
    complemento(value) {
      if (this.isMounted) {
        this.saveToLocalStorage('complemento', value);
      }
    },
    faixaEtaria(value){
      if (this.isMounted) {
        this.saveToLocalStorage('faixaEtaria', value);
      }
    }
  },
  methods: {
    submitRegistroOcorrencia(form) {
      console.log('Dados enviados:', form)
      this.showModalRegistro = false
    },

    voltarParaLista() {
      this.$router.push("/lista");
    },
    fechUserInfos() {
      if(this.user.campo_id && !this.user.showCampoInput)
          this.campoSelected = this.user.campo_id;

      if(this.user.igreja_id && !this.user.showFilialInput)
          this.igrejaSelected = this.user.igreja_id;

      if (this.user.setor !== undefined && this.user.setor !== null && !this.user.showSetorInput) 
          this.setorSelected = this.user.setor;

      if(this.user.congregacao_id && !this.user.showCongregacaoInput)
          this.congregacaoSelected = this.user.congregacao_id;
    },

    //viaCEP
    async fetchCityByUf() {
      if (!this.uf) {
        this.cities = []; // Limpa as cidades se não houver UF selecionada
        return;
      }
      
      try {
        const response = await fetch(`https://servicodados.ibge.gov.br/api/v1/localidades/estados/${this.uf}/municipios`);
        const data = await response.json();
        this.cities = data.map(city => ({
            id: city.nome,
            label: city.nome
        }));
      } catch (error) {
        console.error('Erro ao carregar as cidades:', error);
      }


    },
    async buscarEndereco() {
      // Remove qualquer máscara ou espaços do CEP
      if(!this.cep) return;
      
      const cepLimpo = this.cep.replace(/\D/g, '');
      // Valida o formato do CEP
      if (cepLimpo.length !== 8) {
        alert('Por favor, insira um CEP válido.');
        return;
      }

      try {
        // Chama a API do ViaCEP
        const response = await fetch(`https://viacep.com.br/ws/${cepLimpo}/json/`);
        const data = await response.json();
        if (data.erro) {
          alert('CEP não encontrado.');
          return;
        }

        // Preenche os campos com os dados retornados
        this.endereco = data.logradouro || '';
        this.bairro = data.bairro || '';
        this.cidade = data.localidade || '';


      } catch (error) {
        console.error('Erro ao buscar o endereço:', error);
        alert('Erro ao buscar o endereço. Tente novamente.');
      }
    },

    changeSelects() {

        const params = new URLSearchParams();
        if (this.campoSelected) {
          params.append('campo_id', this.campoSelected);
        }

        if (this.igrejaSelected) {
          params.append('igreja_id', this.igrejaSelected);
        }

        if (this.setorSelected !== undefined && this.setorSelected !== null) {
          params.append('setor', this.setorSelected);
        }

        if (this.user.user_id) {
          params.append('user_id', this.user.user_id);
        }
        // if (this.congregacaoSelected && !this.user.showSetorInput) {
        //   params.append('congregacao_id', this.congregacaoSelected);
        // }
        const url = `${environment.apiUrl}congregacoes/getAllFilters?${params.toString()}`;
        fetch(url)
          .then(response => response.json())
          .then(data => {
            this.campos = data.campos;

            if(this.campoSelected)
                this.igrejas = data.igrejas;

            if(this.igrejaSelected)          
                this.setores = data.setores;

            if(this.setorSelected !== undefined && this.setorSelected !== null && this.setorSelected !== "")
                this.congregacoes = data.congregacoes;

            if (this.campoSelected !== undefined && this.campoSelected !== null && this.campoSelected !== "") {
                if (this.campoSelected == 1) {
                    this.igrejaSelected = 86;
                }

                if (this.igrejas.length === 1) {
                    this.igrejaSelected = this.igrejas[0].id; 
                }
            }

            if (this.igrejaSelected !== undefined && this.igrejaSelected !== null && this.igrejaSelected !== "") {
                if (this.setores.length === 1) {
                    this.setorSelected = this.setores[0]; 
                }
            }

            if (this.setorSelected !== undefined && this.setorSelected !== null && this.setorSelected !== "") {
                if (this.congregacoes.length === 1) {
                    this.congregacaoSelected = this.congregacoes[0].id; 
                } else if(this.igrejaSelected == 86 && this.setorSelected == 0) {
                    this.congregacaoSelected = this.congregacoes[0].id;
                }
            }
          })
          .catch(error => {
            console.error('Erro ao buscar os dados:', error);
          });

    },

    // LOCAL STORAGE
    loadFromLocalStorage() {
      if(!this.isEdicao)
        {
          //Congregacionais
          this.campoSelected = JSON.parse(localStorage.getItem('campoSelected')) || '';
          this.igrejaSelected = JSON.parse(localStorage.getItem('igrejaSelected')) || '';
          this.setorSelected = JSON.parse(localStorage.getItem('setorSelected'));
          this.congregacaoSelected = JSON.parse(localStorage.getItem('congregacaoSelected')) || '';

          //pessoais
          this.nome = JSON.parse(localStorage.getItem('nome')) || '';
          this.data_nascimento = JSON.parse(localStorage.getItem('data_nascimento')) || '';
          this.telefone_celular = JSON.parse(localStorage.getItem('telefone_celular')) || '';

          //endereco
          this.cep = JSON.parse(localStorage.getItem('cep')) || '';
          this.endereco = JSON.parse(localStorage.getItem('endereco')) || '';
          this.bairro = JSON.parse(localStorage.getItem('bairro')) || '';
          this.cidade = JSON.parse(localStorage.getItem('cidade')) || '';
          this.uf = JSON.parse(localStorage.getItem('uf')) || 'RN';
          this.numero = JSON.parse(localStorage.getItem('numero')) || '';
          this.complemento = JSON.parse(localStorage.getItem('complemento')) || '';

          //decisao
          // dataConversao sempre será a data de hoje, não carrega do localStorage
          this.podeSerVisitado = JSON.parse(localStorage.getItem('podeSerVisitado')) || '';
          this.tipoDeDecisao = JSON.parse(localStorage.getItem('tipoDeDecisao')) || '';
          this.faixaEtaria = JSON.parse(localStorage.getItem('faixaEtaria')) || '';
          this.localDecisao = JSON.parse(localStorage.getItem('localDecisao')) || '';

          // Se a congregação 101426 estiver selecionada, define local de decisão como "Outro"
          if (this.congregacaoSelected === 101426) {
            this.localDecisao = 'Outro';
          }
      }
    },

    saveToLocalStorage(key, value) {
        if(!this.isEdicao)
        {
            localStorage.setItem(key, JSON.stringify(value));
        }
    },

    //MASCARAS
    formatarDataAtual() {
      const hoje = new Date();
      const dia = String(hoje.getDate()).padStart(2, '0');
      const mes = String(hoje.getMonth() + 1).padStart(2, '0'); // Mês é 0-indexado
      const ano = hoje.getFullYear();
      this.dataConversao = `${dia}/${mes}/${ano}`; // Retorna a data no formato DD/MM/YYYY
    },

    // enviando formulario
    sendData() {
      const postData = {
        congregacao_id: this.congregacaoSelected,
        nome: this.nome,
        data_nascimento: this.data_nascimento,
        telefone_celular: this.telefone_celular,
        endereco: this.endereco,
        numero: this.numero,
        complemento: this.complemento,
        data_conversao: this.dataConversao,
        local_decisao: this.localDecisao,
        pode_visita: this.podeSerVisitado,
        cep: this.cep,
        uf: this.uf,
        cidade: this.cidade,
        bairro: this.bairro,
        tipo_decisao: this.tipoDeDecisao,
        faixa_etaria: this.faixaEtaria,
        informacoes_adicionais: this.informacoesAdicionais
      };
      
      const url = `${environment.apiUrl}colheita/autocadastro`;

      fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json', // <- ESSENCIAL!
          'Authorization': `Bearer ${this.token}`
        },
        body: JSON.stringify(postData), // Envia os dados como JSON
      })
        .then(response => response.json())
        .then(data => {
          if (!data.acao) {
            this.$nextTick(() => {
              const firstErrorField = document.querySelector('.error, .error-border, .text-danger');
              if (firstErrorField) {
                firstErrorField.scrollIntoView({ behavior: 'smooth', block: 'center' });
              }
            });

            this.errors = data.errors;
          } else 
          {
            this.errors = {};
            this.nome = '';
            this.data_nascimento = '';
            this.telefone_celular = '';
            this.endereco = '';
            this.localDecisao = '';
            this.podeSerVisitado = '';
            this.cep = '';
            this.uf = '';
            this.cidade = '';
            this.bairro = '';
            this.faixaEtaria = '';
            this.TipoDeDecisao = '';
            // Data de decisão sempre é a data de hoje
            this.formatarDataAtual();

            this.$router.push('/sucesso/' + data.num_ficha);
          }


        })
        .catch(error => {
          console.error('Erro ao enviar os dados:', error);
          this.$router.push('/falha');
        });

    },

    //atualizando formulario
    updateData() {
        const postData = {
          id: this.$route.params.num_ficha,
          campo_id: this.campoSelected,
          igreja_id: this.igrejaSelected,
          setor_id: this.setorSelected,
          congregacao_id: this.congregacaoSelected,
          nome: this.nome,
          data_nascimento: this.data_nascimento,
          telefone_celular: this.telefone_celular,
          endereco: this.endereco,
          numero: this.numero,
          complemento: this.complemento,
          data_conversao: this.dataConversao,
          local_decisao: this.localDecisao,
          pode_visita: this.podeSerVisitado,
          cep: this.cep,
          uf: this.uf,
          cidade: this.cidade,
          bairro: this.bairro,
          tipo_decisao: this.tipoDeDecisao,
          faixa_etaria: this.faixaEtaria,
          informacoes_adicionais: this.informacoesAdicionais,

          origem: this.origem,
          endereco_localizado: this.endereco_localizado,
          participa_betel: this.participa_betel,
          sendo_discipulado: this.sendo_discipulado,

          ebd_inicio: this.ebd_inicio,
          ebd_inicio_data: this.ebd_inicio_data,
          ebd_conclusao: this.ebd_conclusao,
          ebd_conclusao_data: this.ebd_conclusao_data,

          curso_biblico_individual_inicio: this.curso_biblico_individual_inicio,
          curso_biblico_individual_inicio_data: this.curso_biblico_individual_inicio_data,
          curso_biblico_individual_conclusao: this.curso_biblico_individual_conclusao,
          curso_biblico_individual_conclusao_data: this.curso_biblico_individual_conclusao_data,

          curso_biblico_ar_inicio: this.curso_biblico_ar_inicio,
          curso_biblico_ar_inicio_data: this.curso_biblico_ar_inicio_data,
          curso_biblico_ar_conclusao: this.curso_biblico_ar_conclusao,
          curso_biblico_ar_conclusao_data: this.curso_biblico_ar_conclusao_data,

          discipulado_inicio: this.discipulado_inicio,
          discipulado_inicio_data: this.discipulado_inicio_data,
          discipulado_conclusao: this.discipulado_conclusao,
          discipulado_conclusao_data: this.discipulado_conclusao_data
        };
        
        const url = `${environment.apiUrl}colheita/update`;

        fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json', // <- ESSENCIAL!
            'Authorization': `Bearer ${this.token}`
          },
          body: JSON.stringify(postData),
        })
          .then(response => response.json())
          .then(data => {

            if (!data.acao) {
              this.$nextTick(() => {
                const firstErrorField = document.querySelector('.error, .error-border, .text-danger');
                if (firstErrorField) {
                  firstErrorField.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
              });

              this.errors = data.errors;
            } else {
              console.log('Dados enviados com sucesso:', data);
              this.$router.push('/atualizado/' + data.num_ficha);
            }
          })
          .catch(error => {
            console.error('Erro ao enviar os dados:', error);
            this.$router.push('/falha');
          });

    },
    
    async getFicha() {
        try {
            const fichaData = await colheitaService.getFicha(this.num_ficha, this.token);
            Object.assign(this, fichaData);
        } catch (error) {
            window.location.href = '/lista';
        }
    },
    toggleEdit() {
        this.isEditable = !this.isEditable;
    },

    limparDados() {
      if (this.user.showCampoInput) {
        this.campoSelected = '';
      }
      if (this.user.showFilialInput) {
        this.igrejaSelected = '';
        this.igrejas = '';
      }
      if (this.user.showSetorInput) {
        this.setorSelected = '';
        this.setores = '';
      }
      if (this.user.showCongregacaoInput) {
        this.congregacaoSelected = '';
        this.congregacoes = '';
      }
      this.nome = '';
      this.data_nascimento = '';
      this.telefone_celular = '';
      this.cep = '';
      this.endereco = '';
      this.numero = '';
      this.bairro = '';
      this.complemento = '';
      this.tipoDeDecisao = '';
      this.localDecisao = '';
      this.podeSerVisitado = '';
      this.cidade = '';
      this.uf = 'RN';
      this.errors = {};
      this.showModal = false;
      this.faixaEtaria = '';
      // Data de decisão sempre é a data de hoje
      this.formatarDataAtual();

    },
    validarInformacoesAdicionais()
    {
      if (this.informacoesAdicionais.length > 200) {
        this.errors.informacoesAdicionais = "O texto não pode ter mais de 200 caracteres.";
        this.informacoesAdicionais = this.informacoesAdicionais.substring(0, 200);
      } else {
        this.errors.informacoesAdicionais = "";
      }
    },
    formatarNumero(event) {
        // Remove tudo que não for número
        let numero = event.target.value.replace(/\D/g, '');
        // Atualiza o valor do campo
        this.numero = numero;
    },

    goToHistorico() {
        this.$router.push(`/historico/${this.num_ficha}`);
    },
    toggleModalOcorrencia() {
      this.showModalRegistro = !this.showModalRegistro;
    }
  },
};
</script>

<style scoped>

  body {
    background-color: rgb(249, 250, 251) !important;
  }

  input, .form-select, .form-control {
    border-radius: .75rem !important;
    margin-bottom: 10px !important;
    height: 66px !important;
    border-color: rgb(229, 231, 235) !important;
  }

  .form-floating.mb-3, .mb-3 {
    margin-bottom: 0 !important;
    margin-bottom: 10px !important;
  }

  .submit_button {
    border-color: #136A9F !important;
    color: rgb(255, 255, 255) !important;
  }

  .select2-search__field {
    padding: 10px !important;
  }

  .form-floating>label {
    display: flex;
    align-items: center;
  }

  .text-danger {
    width: 100%;
    text-align: left;
    padding: 5px;
  }

  .input_border_dunger {
    border-color: red!important;
  }

  .back_button {
    cursor: pointer;
  }

  button.btn.btn-primary.form-control.submit_button {
    padding-left: 12px !important;
    font-weight: bolder !important;
  }

  .select2-container--open .select2-dropdown--below, .select2-container--open .select2-dropdown--above {
    border: 1px solid lightgray !important;
    border-radius: .75rem !important;
  }

  .select2-container--default .select2-results > .select2-results__options {
    scrollbar-width: thin;
  }

  .select2-container--default .select2-results__option--highlighted.select2-results__option--selectable {
    background-color: #A68B3C !important;
    color: white;
  }

  .select2-container--default .select2-search--dropdown .select2-search__field {
    border: 1px solid #aaa;
    height: 36px !important;
    border-radius: .75rem !important;
  }

  .form-control:not(:placeholder-shown) {
    padding-left: 43px !important;
  }

  input {
    padding-top: 13px !important;
  } 

  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1050;
  }

  .custom-select-with-label {
    position: relative;
    width: 100%;
    margin-bottom: 10px;
  }

/* Estilo do label flutuante */
.float-label {
    position: absolute;
    top: 6px;
    left: 43px;
    font-size: 14px;
    padding: 0 4px;
    z-index: 1;
    transition: all 0.2sease;
    color: rgba(var(--bs-body-color-rgb), .65);
}

/* Ajuste o placeholder do Select para evitar sobreposição */
.el-select ::v-deep .el-input__inner::placeholder {
  color: transparent; /* Esconde o placeholder */
}
.error-border {
  border: 1px solid red !important; /* Borda vermelha */
  border-radius: 0.75rem !important; /* Border radius */
}

.btn_editar {
    background: #114c74 !important;
    border: 1px solid #114c74 !important;
    font-weight: bolder !important;
    transition: .5s !important;
}

.btn_editar:hover {
  background: transparent !important;
  color: #114c74 !important;
  transition: .5s !important;
}

.btn-registrar-ocorrencia {
  background-color: #2AC070; 
  border-color: #2AC070;
}

.btn-registrar-ocorrencia:hover {
  background-color: transparent; 
  color: #2AC070; 
  border-color: #2AC070;
}
</style>